<p-splitter [style]="{ height: '50rem' }"
            [panelSizes]="[20, 80]"
            [minSizes]="[15, 70]"
            styleClass="col-12">
    <!-- Link-Paneel -->
    <ng-template pTemplate>
        <div class="formgrid full-width">
            <h2>Preferences</h2>
            <hr>
            <div>
                <ul>
                    <li>
                        <p style="cursor:pointer" (click)="onEdit2faSettings()">2FA (open in new window)</p>
                    </li>
                    <li>
                        <p style="cursor:pointer" (click)="editProfile()">Profile (open in new window)</p>
                    </li>
                    <!-- Navigation zu Properties -->
                    <li class="cursor-pointer">
                        <a (click)="navigateTo('properties')">Properties</a>
                    </li>
                </ul>
            </div>
        </div>
    </ng-template>

    <!-- Inhalt-Paneel -->
    <ng-template pTemplate>

        <div class="card" style="    width: 100%;    height: 100%; ">

            <ng-template [ngIf]="selected=='properties'">
                <app-properties>

                </app-properties>

            </ng-template>

        </div>
    </ng-template>
</p-splitter>


